import { render, staticRenderFns } from "./contract-management.vue?vue&type=template&id=db2424de"
import script from "./contract-management.vue?vue&type=script&lang=js"
export * from "./contract-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports